"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var client_1 = require("@apollo/client");
var ActionTypes_1 = require("./ActionTypes");
var ApolloLinkNetworkStatus = /** @class */ (function (_super) {
    __extends(ApolloLinkNetworkStatus, _super);
    function ApolloLinkNetworkStatus(dispatcher) {
        var _this = _super.call(this) || this;
        _this.dispatcher = dispatcher;
        return _this;
    }
    ApolloLinkNetworkStatus.prototype.request = function (operation, forward) {
        var _this = this;
        this.dispatcher.dispatch({
            type: ActionTypes_1["default"].REQUEST,
            payload: { operation: operation }
        });
        var subscriber = forward(operation);
        return new client_1.Observable(function (observer) {
            var isPending = true;
            var subscription = subscriber.subscribe({
                next: function (result) {
                    isPending = false;
                    _this.dispatcher.dispatch({
                        type: ActionTypes_1["default"].SUCCESS,
                        payload: { operation: operation, result: result }
                    });
                    observer.next(result);
                },
                error: function (networkError) {
                    isPending = false;
                    _this.dispatcher.dispatch({
                        type: ActionTypes_1["default"].ERROR,
                        payload: { operation: operation, networkError: networkError }
                    });
                    observer.error(networkError);
                },
                complete: observer.complete.bind(observer)
            });
            return function () {
                if (isPending) {
                    _this.dispatcher.dispatch({
                        type: ActionTypes_1["default"].CANCEL,
                        payload: { operation: operation }
                    });
                }
                if (subscription) {
                    subscription.unsubscribe();
                }
            };
        });
    };
    return ApolloLinkNetworkStatus;
}(client_1.ApolloLink));
exports["default"] = ApolloLinkNetworkStatus;
